import { computed } from 'vue';
import { useAuthStore } from '@/stores/authStore';
import { podeVerCentralFinanceiro } from '@/utils/reembolsoCentral';
import { isRestrictedRoute } from '@/utils/restrictedRoutes';
import { useReembolsoConferenteFlag } from './useReembolsoConferenteFlag';

/** Rota da configuração do Reembolso: admin dela é o "analista do financeiro" (decisão 4, 09/10). */
const CONFIG_ROUTE = '/reembolso/configuracoes';

/**
 * Entrada "Central do financeiro" no menu: conferente (pool/departamento) OU admin da
 * configuração do Reembolso — este último vê a Central mesmo fora do pool. Só decide a
 * VISIBILIDADE do item; o que cada um pode fazer lá continua decidido pelo servidor.
 * `null` = ainda carregando (o menu mantém o item para não piscar).
 */
export function useReembolsoCentralFlag() {
  const authStore = useAuthStore();
  const { isConferente } = useReembolsoConferenteFlag();
  const podeVer = computed(() => podeVerCentralFinanceiro(
    isConferente.value,
    authStore.userAccessMap.get(CONFIG_ROUTE),
    // Mesma regra do menu/guard: admin master não tem bypass em rota restrita.
    authStore.isAdminMaster && !isRestrictedRoute(CONFIG_ROUTE),
  ));
  return { podeVer };
}
